import axios from "axios"
import * as env from "../constants/env"


/* List Dealer */
export const list = (page, search = "", studioIDs = []) => {
    const studioParam = studioIDs.length > 0 ? `&studioIDs=${studioIDs.join(",")}` : ""
    const uri = `${env.startpoint}dealer/list?page=${page}&search=${encodeURIComponent(search)}${studioParam}`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get(uri, headers).then((response) => response).catch((data) => data.response)
}

/* Form Variables */
export const variables = () => {
    const uri = `${env.startpoint}dealer/variables`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get(uri, headers).then((response) => response).catch((data) => data.response)
}

/* Get Dealer */
export const get = (data) => {
    const uri = `${env.startpoint}dealer/get`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* Create Dealer */
export const create = (data) => {
    const uri = `${env.startpoint}dealer/create`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* Edit Dealer */
export const edit = (data) => {
    const uri = `${env.startpoint}dealer/edit`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* Remove Dealer */
export const remove = (data) => {
    const uri = `${env.startpoint}dealer/remove`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}
